import { useState } from "react";
import { DueDiligenceTier } from "../../Types-DTOs/DueDiligence";
import { useDueDiligence } from "./index";
import { isErr } from "../../Utils/Result";
import { eventBus } from "../../EventBus";
import { Notification } from "../../../Components/Notifications";

export const useDueDiligenceUpsellPayment = (caseId: string | undefined) => {
  const [payingTier, setPayingTier] = useState<DueDiligenceTier | null>(null);
  const isPayingNow = payingTier !== null;
  const { getUpsellPaymentUrl } = useDueDiligence();

  const handleUpsellPayNow = async (toTier: DueDiligenceTier, promotionCode?: string) => {
    if (!caseId || isPayingNow) return;
    setPayingTier(toTier);
    const result = await getUpsellPaymentUrl(caseId, toTier, promotionCode);
    if (!isErr(result)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.location.href = (result.value as any).paymentUrl;
    } else {
      setPayingTier(null);
      eventBus.emit("NOTIFICATION", Notification.buildNotification("error", "Error obteniendo link de pago de la ampliación"));
    }
  };

  return { isPayingNow, payingTier, handleUpsellPayNow };
};
